export default __webpack_public_path__ + "static/media/team1.29c0e251.png";